export default __webpack_public_path__ + "static/media/favicon.42f9f519.jpg";